var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@telus-uds/components-web';
import Icons from '@telus-uds/palette-koodo/build/web/icons';
import styled from 'styled-components';
export var SelectionIcon = function (_a) {
    var hideCheckOnSelect = _a.hideCheckOnSelect, open = _a.open, isDesktop = _a.isDesktop, _b = _a.hideIconOnSelect, hideIconOnSelect = _b === void 0 ? false : _b, color = _a.color;
    var dontShowIcon = open && hideIconOnSelect;
    if (dontShowIcon) {
        return _jsx(_Fragment, {});
    }
    var hide = open && hideCheckOnSelect;
    var Wrapper = open && isDesktop ? SelectedWrapper : SelectionIconWrapper;
    return (_jsx(Wrapper, { children: isDesktop ? (!hide && (_jsx(Icon, { icon: open ? Icons.Check : Icons.ChevronRight, tokens: { color: color !== null && color !== void 0 ? color : 'black' } }))) : (_jsx(Icon, { icon: open ? Icons.ChevronUp : Icons.ChevronDown, tokens: { color: color !== null && color !== void 0 ? color : 'black' }, variant: { size: 'small' } })) }));
};
// --------------------------- STYLES --------------------------- //
var SelectionIconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 24px;\n"], ["\n  position: absolute;\n  right: 24px;\n"])));
var SelectedWrapper = styled(SelectionIconWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  right: 24px;\n"], ["\n  right: 24px;\n"])));
var templateObject_1, templateObject_2;
